import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import managerAPI from '../../sources/api/managerAPI';

// constants
import { INFORM_PREMIUM_FOLLOWES } from '../../constants/currentManagerTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { SEND_MASS_EMAIL_MESSAGE_SUCCESS, SEND_MASS_EMAIL_MESSAGE_ERROR } from '../../constants/messages';

export function* informPremiumFollowers(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield* httpSaga(INFORM_PREMIUM_FOLLOWES, call(managerAPI.informPremiumFollowers, params));
    yield toastr.success('Success', SEND_MASS_EMAIL_MESSAGE_SUCCESS);
  } catch (e) {
    const errors = handleServerValidation('manager', e.response.body.details, { nestedPath: true });

    yield toastr.error(SEND_MASS_EMAIL_MESSAGE_ERROR);
    yield put(error(INFORM_PREMIUM_FOLLOWES, errors));
  } finally {
    yield put(doneIndicator(INFORM_PREMIUM_FOLLOWES));
  }
}

export function* watchInformPremiumFollowers() {
  yield takeEvery(INFORM_PREMIUM_FOLLOWES, informPremiumFollowers);
}

export default function* root() {
  yield all([
    fork(watchInformPremiumFollowers)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/manager/informPremiumFollowers.js